import Section from '../Section'
import './page-title.scss'

type TPageTitle = {
  pageTitle: string
}

const PageTitle = ({ pageTitle }: TPageTitle) => {
  return (
    <Section className="layout__section layout__content">
      <div className="page-title-container">
        <h2 className="page-title">{pageTitle}</h2>
        <div className="black-border" />
      </div>
    </Section>
  )
}

export default PageTitle
